import { actionChannel, all, put, take } from 'typed-redux-saga';
import { watchConnectPrayerStreamUserRequestsSaga } from '../async-action/connect-prayer-stream-user/connect-prayer-stream-user.saga';
import { watchGetCommunityGroupListSaga } from '../async-action/get-community-group-list/get-community-group-list.saga';
import { getPrayerStreamUserRegistrationSlice } from '../async-action/get-prayer-stream-user-registration/get-prayer-stream-user-registration.slice';
import { watchRegisterPrayerStreamUserRequestsSaga } from '../async-action/register-prayer-stream-user/register-prayer-stream-user.saga';
import { watchUserGroupMembershipSaga } from '../async-action/update-user-group-membership/update-user-group-membership.saga';

export function* prayerStreamSaga(): Generator {
  const channel = yield* actionChannel(
    getPrayerStreamUserRegistrationSlice.actions
      .getPrayerStreamUserRegistrationSucceeded,
  );
  yield* put(
    getPrayerStreamUserRegistrationSlice.actions.getPrayerStreamUserRegistrationRequested(),
  );
  yield* take(channel);
  yield* all([
    watchConnectPrayerStreamUserRequestsSaga(),
    watchGetCommunityGroupListSaga(),
    watchRegisterPrayerStreamUserRequestsSaga(),
    watchUserGroupMembershipSaga(),
  ]);
}
